import * as React from 'react'
import { RouterAction } from 'react-router-redux'

import { Site } from '../../../../common/constants/siteList'
import { ILocationParams } from '../../../../common/reducers/reactRouterLocation'
import { filterSortByOptions } from '../../../../common/utils/item'
import { getConfigBySite } from '../../../../config/sites'
import siteDefaultConfigs from '../../../../config/sites/defaults'
import Dropdown from '../../../shared/components/dropdown'
import ChevronDownIcon from '../../../shared/components/icons/chevronDown'
import SortByIcon from '../../../shared/components/icons/sortBy'

import * as styles from './sortBy.module.css'

const searchQueryConfigs = siteDefaultConfigs.search_query
const defaultSortByOptions = searchQueryConfigs.default_sort_by_options

interface IProps {
  locationParams: ILocationParams
  currentSite: Site
  makeSearchLink: (params: ILocationParams, currentSite?: Site) => string
  push: (path: string) => RouterAction
}

/**
 * A sort by menu which has lots of business logic
 */
class SortByDropdown extends React.Component<IProps> {
  constructor(props: IProps) {
    super(props)
    this.onSortBySelectionChange = this.onSortBySelectionChange.bind(this)
  }

  public render() {
    const { locationParams, currentSite } = this.props

    const sortByOptions = filterSortByOptions(
      currentSite,
      locationParams,
      defaultSortByOptions
    )
    const selectedSortByValue = this.getSelectSortByValue(locationParams)

    // Append "Sort by:" to selected label
    const sortByOptionsWithLabel = sortByOptions.map(option => {
      if (option.value === selectedSortByValue) {
        return {
          ...option,
          label: `Sort by: ${option.label}`
        }
      } else {
        return option
      }
    })

    return (
      <div className={styles.sortByWrapper}>
        <label htmlFor="sortby" className={styles.sortByLabel}>
          Sort by:{' '}
        </label>
        <SortByIcon width="20" height="12" className={styles.sortIcon} />
        <Dropdown
          id="sortby"
          name="sortby"
          className={styles.sortBySelect}
          options={sortByOptionsWithLabel}
          onChange={this.onSortBySelectionChange}
          value={selectedSortByValue}
        />
        <ChevronDownIcon
          width="22"
          height="14"
          className={styles.chevronIcon}
        />
      </div>
    )
  }

  private getSelectSortByValue(parsedLocation: any) {
    let sortOrder

    if (parsedLocation.sort_by) {
      sortOrder =
        parsedLocation.sort_by === 'price' && parsedLocation.sort_direction
          ? 'price-' + parsedLocation.sort_direction
          : parsedLocation.sort_by
    } else {
      if (parsedLocation.term) {
        sortOrder = 'relevance'
      } else {
        sortOrder = getConfigBySite(
          this.props.currentSite,
          'search_query.default_sort_by'
        )
      }
    }

    return sortOrder
  }

  private onSortBySelectionChange(event: React.ChangeEvent<HTMLSelectElement>) {
    const { push, locationParams, makeSearchLink } = this.props

    const sort = event.target.value
    const newQuery: ILocationParams = {
      ...locationParams,
      sort
    }
    delete newQuery.sort_by
    delete newQuery.sort_direction

    push(makeSearchLink(newQuery, this.props.currentSite))
  }
}

export const SortByDropdownComponent = SortByDropdown
export default SortByDropdown
